import { render, staticRenderFns } from "./u-dialog-underline-rounded.vue?vue&type=template&id=6c7e2087&scoped=true"
import script from "./u-dialog-underline-rounded.vue?vue&type=script&lang=js"
export * from "./u-dialog-underline-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7e2087",
  null
  
)

export default component.exports